import { useTheme } from '@mui/material';

import { useMapPreferences } from './useMapPreferences';

/**
 * Returns text/divider colors appropriate for the current map surface mode.
 * Use when placing content over a `GoogleMapsElement` so the text inverts
 * with the map mode toggle without a dedicated theme swap.
 */
export const useMapSurfaceColors = () => {
  const theme = useTheme();
  const { mode } = useMapPreferences();
  const isLight = mode === 'light';

  const panelBackground = isLight
    ? `${theme?.palette?.background?.paper}99`
    : `${theme?.palette?.utility?.main}60`;

  return {
    mode,
    isLight,
    primary: isLight ? theme?.palette?.text?.primary : theme?.palette?.text?.contrastPrimary,
    secondary: isLight ? theme?.palette?.text?.secondary : theme?.palette?.text?.contrastSecondary,
    disabled: isLight ? theme?.palette?.text?.disabled : theme?.palette?.text?.contrastDisabled,
    divider: isLight ? theme?.palette?.divider : theme?.palette?.dividerContrast,
    panelBackground,
  };
};
